/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from 'react'
import { LABEL_UPDATE_USERS, LABEL_UPDATE_PERMISSION, UPDATE_ROLE_NAME, UPDATE_ROLE_DESC, UPDATE_ROLE_SUCCESS_MESSAGE, LABEL_BTN_CANCEL, LABEL_BTN_SAVE, UNKNOWN_ERR } from '../../constants/constant';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import UsersTab from './UsersTab';
import PermissionTab from './PermissionTab';
//@ts-ignore
import { NotificationManager } from 'react-notifications';
import { addMenuPermissions, addUsersToRole, getAllMenuPermissionsById, getAllUsersById, updateRole } from 'src/services/roleService';

interface UpdateroleProps {
    selectedRoleInfo: any;
    closeModal: () => void;
    refreshPage: () => void;
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

interface IUsersData {
    id?: any | null;
    firstName: string;
    lastName?: string | null | undefined;
    email: string;
    password: string;
    clientId: number;
    passwordResetKey?: any | null;
    resetKeySentOn?: any | null;
    isDeleted: boolean;
    isActive: boolean;
    timeZone?: any | null;
    phone?: any | null;
    roleId?: any | null;
    createdBy: string;
    createdOn: string;
    createdSource: string;
    modifiedBy?: any | null;
    modifiedOn?: any | null;
    modifiedSource?: any | null;
    //For user role
    hasRole: boolean;
    name: string;
    userID:any;
    hasWebAccess: boolean;
    hasAPIAccess : boolean;
    roleName: string | null;
  }

  interface IMenuData {
    menuId: number;
    roleId: number;
    sortOrder: number;
    isDisplay: boolean;
    menuName: string;
    menuFeaturePermissions: MenuFeaturePermission[];
}

interface MenuFeaturePermission {
    menuFeatureId: number;
    menuFeature: string;
    hasPermission: boolean;
}

interface ApiResponse {
    status: number;
    data: {
        result: number;
        data: any;
    };
}

function CustomTabPanel(props: TabPanelProps):JSX.Element {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 0 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number): any {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function UpdateRole({selectedRoleInfo, closeModal, refreshPage}: UpdateroleProps): JSX.Element {

    //@ts-ignore
    const [roleName, setRoleName] = useState<string>(selectedRoleInfo?.roleName || '');
    //@ts-ignore
    const [description, setDescription] = useState<string>(selectedRoleInfo?.description || '');
    const [isEditing, setIsEditing] = useState(false);
    const [value, setValue] = React.useState(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [roleUserData, setRoleData] = useState<IUsersData[]>([]);
    const [menuData, setMenuData] = useState<IMenuData[]>([]);
    const [userSearchData, setUserSearchData] = useState<IUsersData[]>([])
    const [menuSearchData, setMenuSearchData] = useState<IMenuData[]>([])
    const [selectedUserIds, setSelectedUserIds] = useState<number[]>([]);
    const [selectedMenuFeatureIds, setSelectedMenuFeatureIds] = useState<number[]>([]);
    const [isError, setIsError] = useState<boolean>(false)
    const [isSaveLoading, setIsSaveLoading] = useState<boolean>(false)

    const initialized = useRef(false)

    useEffect(() => {
        if (selectedRoleInfo && !isEditing) {
            setRoleName(selectedRoleInfo.roleName);
            setDescription(selectedRoleInfo.description);
        }
    }, [selectedRoleInfo,selectedMenuFeatureIds]);

    useEffect(() => {
        setLoading(true);
        const roleId = sessionStorage.getItem('roleId'); // Retrieve roleId from session storage
        //@ts-ignore
        getAllUsersById(roleId).then((res: ApiResponse) => {
            if (res.status === 200 && res.data.result === 1) {
                const userDataWithAdditionalInfo = res.data.data.map((user: any) => ({
                    ...user,
                    fullname: `${user.name}`, // Combine first and last name
                    userID: user.userID, // User ID
                    hasRole: user.hasRole
                }));
                setRoleData(userDataWithAdditionalInfo);
                setUserSearchData(userDataWithAdditionalInfo)
                setLoading(false);
                const ids: any = []
                userDataWithAdditionalInfo.map((userData: any) => {
                    if (userData.hasRole) {
                        ids.push({ "id": userData.userID })
                    }
                })
                setSelectedUserIds(ids);
            }
        })
        .catch(error => console.log("Error", error))
    }, []);

    useEffect(() => {
        if (!initialized.current) {
            
            setLoading(true);
            const roleId = sessionStorage.getItem('roleId'); // Retrieve roleId from session storage
            if (roleId) {
                //@ts-ignore
                getAllMenuPermissionsById(roleId).then((res: any) => {
                    if (res.status === 200 && res.data.result === 1) {
                        const roleDataWithPermission = res.data.data.map((permission: any) => ({
                            ...permission,
                            roleid: permission.roleId, // Role ID
                            rolename: 'Role Name',
                        }));
                        setMenuData(roleDataWithPermission);
                        setMenuSearchData(roleDataWithPermission)
                        setLoading(false);
                        initialized.current = true;
                    }
                })
                    .catch(error => console.log("Error", error))
            }
        }
    }, []);

    const handleEditRole = ():void => {
        setIsEditing(true);
    }

    // const handleCancel = (): void => {
    //     setIsEditing(false);
    // };

    const handleSaveRole = ():void => {
        // Call the roleService to update the role data

        // @ts-ignore
        const userData = JSON.parse(localStorage.getItem("user"))

        if (roleName === "") {
            setIsError(true);
            return;
        }
        const uniqueMenuFeatureIds = Array.from(new Set(selectedMenuFeatureIds)); // Remove duplicates
        const uniqueUserIds = Array.from(new Set(selectedUserIds)); // Remove duplicates

        if (uniqueMenuFeatureIds.length === 0) {
            NotificationManager.error("Please select menu permissions", '', 5000);
        } else if (uniqueUserIds.length === 0) {
            NotificationManager.error("Please select users", '', 5000);
        } else {
        const updatedRoleData: any = {
            "id": sessionStorage.getItem('roleId'),
            "roleName": roleName ? roleName.trim() : roleName,
            "description": description ? description.trim() : description,
        }
        const userIds: any = [];

        uniqueUserIds.map((id: any) => {
            if (id.id) {
                userIds.push(id)
            } else {
                userIds.push({ "id": id })
            }
            // ({ "id": id })
        })

        const updatedUserdatatorole: any = {
            "userId": userIds,
            "roleId": sessionStorage.getItem('roleId'),
            "createdBy": userData.id,
            "createdSource": 'string',
        }

        const menuFeatureIDs: any = [];
        selectedMenuFeatureIds.map((item: any) => {
            if (item.menuFeatureId) {
                menuFeatureIDs.push({
                    menuFeatureId: item.menuFeatureId
                })
            } else {
                menuFeatureIDs.push({
                    menuFeatureId: item
                })
            }
        });
        const uniqueMenuFeatureIDs = Array.from(
            new Set(menuFeatureIDs.map((item: { menuFeatureId: any }) => item.menuFeatureId))
        ).map(menuFeatureId => ({ menuFeatureId }));

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const updatepermissiondatatorole = {
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            "roleId": parseInt(sessionStorage.getItem('roleId') || "0", 10), // Ensure roleId is a number
            menuFeatureIDs: uniqueMenuFeatureIDs,
            createdBy: 0,
        };
        console.log(menuFeatureIDs);
        setIsSaveLoading(true);
        updateRole(updatedRoleData)
            .then((response: any) => {
                
                //window.location.reload();
                // props.closeModal("refresh")
                if (response.status === 200) {
                    if (response.data.result === 1) {
                        addUsersToRole(updatedUserdatatorole).then(
                            (res: any) => {
                                if (res.status === 200 && res.data.result === 1) {
                                    // props.closeModal("refresh")

                                }
                                setIsSaveLoading(false)
                            }

                        )
                        .catch(error => console.log("Error", error))

                        addMenuPermissions(updatepermissiondatatorole).then(
                            (res: any) => {
                                if (res.status === 200 && res.data.result === 1) {
                                    setSelectedUserIds([]);
                                    setSelectedMenuFeatureIds([]);

                                }
                                setIsSaveLoading(false)
                            }
                        )
                        .catch(error => console.log("Error", error))
                        NotificationManager.success(UPDATE_ROLE_SUCCESS_MESSAGE, '', 5000);
                        refreshPage();
                        setIsEditing(false);
                    }else {
                        if (response.data.messages.length === 1) {
                            NotificationManager.error(response.data.messages[0].message, '', 5000);
                        } else {
                            NotificationManager.error(UNKNOWN_ERR, '', 5000);
                        }
                    }
                    setIsSaveLoading(false)
                   
                }

            })
            .catch((error: any) => {
                console.error("Error updating role:", error);
                setIsSaveLoading(false)
            }) .finally(() => setIsSaveLoading(false));

        }




    };

    const handleRoleNameChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        if (e.target.value === "") {
            setIsError(true)
        } else {
            setIsError(false)
        }
        setRoleName(e.target.value);
    };

    const handleRoledescriptionChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        setDescription(e.target.value);
    };

    const handleChange = (event: React.SyntheticEvent, newValue: number): void => {
        setValue(newValue);
    };

    const handleUserSearch = (e: any): void => {
        const { value } = e.target;
        let userDataArr = [...roleUserData]
        if (value !== "") {
            userDataArr = userDataArr.filter((user: IUsersData) => {
                return user.name.toLowerCase().includes(value.toLowerCase())
            })
        }
        setUserSearchData(userDataArr)
    }

    const handleMenuSearch = (e: any): void => {
        const { value } = e.target;
        let menuDataArr = [...menuData]
        if (value !== "") {
            menuDataArr = menuDataArr.filter((menu: IMenuData) => {
                return menu.menuFeaturePermissions.some((menuFeature) => {
                    return menuFeature.menuFeature.toLowerCase().includes(value.toLowerCase());
                });
            });
        }
        setMenuSearchData(menuDataArr)
    }

    const handleUserSelect = (userId: number, checked: boolean): void => {
        // setSelectedUserIds(prevState =>
        //     checked
        //         ? [...prevState, userId] // Add userId if it doesn't exist in the array
        //         : prevState.filter(id => id !== userId) // Remove userId if it exists in the array
        // );
        debugger
        if (checked) {
            setSelectedUserIds((prevState: any) => [...prevState, { id: userId }]);
        } else {
            const ids = selectedUserIds.filter((id: any) => id.id !== userId)
            setSelectedUserIds(ids);
        }
    };

    const handleMenuFeatureSelect = (menuFeatureId: any, checked: boolean): void => {
        let selectedIds;
        if (checked) {
            selectedIds = [...selectedMenuFeatureIds, ...menuFeatureId]
        } else {
            const set1: any = new Set(selectedMenuFeatureIds);
            const set2: any = new Set(menuFeatureId);

            const difference = [...set1].filter(
                (element) => !set2.has(element));

            selectedIds = difference
        }
        // const selectedIds = checked ? [...selectedMenuFeatureIds, menuFeatureId] : selectedMenuFeatureIds.filter(id => id !== menuFeatureId)
        setSelectedMenuFeatureIds(selectedIds);
    };
    return (
        <>
            <div className="px-[16px] pt-[10px]">
                <div className="grid">
                    <div className={`mb-[5px] w-full relative role-input-container ${!isEditing ? 'disabled' : ''}`} style={{ marginBottom: '30px' }}>
                        <TextField
                            id="outlined-basic"
                            label={UPDATE_ROLE_NAME}
                            variant="outlined"
                            fullWidth
                            name="RoleName"
                            value={roleName}
                            onChange={handleRoleNameChange}
                            autoComplete="off"
                            InputProps={{
                                style: {
                                    textAlign: "center",
                                    color: '#343434',
                                    fontSize: '18px',
                                    fontWeight: '700',
                                    WebkitTextFillColor: '#343434',
                                    padding: '9px 14px 9px 25px'
                                },
                                placeholder: `${UPDATE_ROLE_NAME}`,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <div className="btn btn-circle btn-circle-small bg-[#fff] hover:bg-[#f5f5f5] border-0 ml-2" style={{ padding: '4px', width: '2rem', height: '2rem', minHeight: '2rem' }} onClick={handleEditRole}>
                                            <img src={'/assets/images/icons/EditIcon.svg'} width={15} height={15} alt="" />
                                        </div>
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                '& input': {
                                    textAlign: 'center',
                                },
                                '& label': {
                                    textAlign: 'center',
                                },
                                backgroundColor: '#F5F5F5',
                            }}
                            disabled={!isEditing}
                            error={isError}
                        />
                        {
                            isError && <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal"><img src="/assets/images/attention.svg" alt="email" width={12} height={12} className="mr-1" /> Please enter role name</div>
                        }
                    </div>
                    {isEditing && (
                        <div className="mb-[5px] w-full relative" style={{ marginBottom: '20px' }}>
                            <TextField
                                id="outlined-basic"
                                label={UPDATE_ROLE_DESC}
                                variant="outlined"
                                fullWidth
                                name="Description"
                                value={description}
                                onChange={handleRoledescriptionChange}
                                autoComplete="off"
                                InputProps={{
                                    // inputProps: {
                                    //     style: { textAlign: "center", color: '#343434', fontSize: '18px', fontWeight: '700', WebkitTextFillColor: '#343434', padding: '9px 14px' },
                                    //     placeholder: `${UPDATE_ROLE_DESC}`
                                    // },
                                    placeholder: `${UPDATE_ROLE_DESC}`,
                                    style: {
                                        textAlign: "center",
                                        color: '#343434',
                                        fontSize: '18px',
                                        fontWeight: '700',
                                        WebkitTextFillColor: '#343434',
                                        padding: '9px 14px 9px 0px'
                                    },
                                    endAdornment: (
                                        <InputAdornment position="end"></InputAdornment>
                                    )
                                }}
                                sx={{
                                    '& input': {
                                        textAlign: 'center',
                                        paddingLeft: "0px"
                                    },
                                    '& label': {
                                        textAlign: 'center',
                                    },
                                    backgroundColor: '#F5F5F5',
                                }}

                            />

                        </div>
                    )}
                </div>
            </div>
            <div className="mt-1">
                <Box sx={{ width: '100%', padding: 0 }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example"
                            TabIndicatorProps={{
                                style: {
                                    backgroundColor: "#D6242C"
                                }
                            }}>
                            <Tab label={LABEL_UPDATE_PERMISSION} {...a11yProps(0)} />
                            <Tab label={LABEL_UPDATE_USERS} {...a11yProps(1)} />
                        </Tabs>
                    </Box>
                    <CustomTabPanel value={value} index={0}>
                        <div className='tab-content'>
                            <div className="form-control mt-2 border-t-[1px] border-b-[1px] border-[#D9D9D9] pb-2" style={{ borderTop: 'none' }}>
                                <input type="text" placeholder="Search permissions" onChange={handleMenuSearch} style={{ border: '0', background: 'transparent url(/assets/images/icons/SearchIcon.svg) no-repeat 22px', paddingLeft: '50px', fontSize: '14px', fontWeight: '400', color: '#3a3a3a' }} />
                            </div>
                        </div>
                        {
                            loading ? <div className='flex justify-center items-center relative top-[50%]'><span className="loading loading-spinner text-primary"></span></div> :
                                <PermissionTab
                                    page={"Permission"}
                                    menuData={menuSearchData}
                                    closeModal={closeModal}
                                    selectedMenuFeatureIds={selectedMenuFeatureIds}
                                    setSelectedMenuFeatureIds={setSelectedMenuFeatureIds}
                                    onMenuFeatureSelect={(menuFeatureId, checked) => handleMenuFeatureSelect(menuFeatureId, checked)}
                                />
                        }
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1} >
                        <div className='tab-content'>
                            <div className="form-control mt-2 border-t-[1px] border-b-[1px] border-[#D9D9D9] pb-2" style={{ borderTop: 'none' }}>
                                <input type="text" placeholder="Search users" onChange={handleUserSearch} style={{ border: '0', background: 'transparent url(/assets/images/icons/SearchIcon.svg) no-repeat 22px', paddingLeft: '50px', fontSize: '14px', fontWeight: '400', color: '#3a3a3a' }} />
                            </div>
                        </div>
                        <UsersTab
                            page={"Users"}
                            roleData={userSearchData}
                            closeModal={closeModal}
                            selectedUserIds={selectedUserIds}
                            setSelectedUserIds={setSelectedUserIds}
                            onUserSelect={(userId, checked) => handleUserSelect(userId, checked)}
                        />
                    </CustomTabPanel>
                </Box>
            </div>
            <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
                <div className="w-full relative col-span-3">
                    <button type='button' className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc] hover:border-[#D9D9D9] disabled:bg-[#f0f0f0] disabled:text-muted" onClick={closeModal} disabled={isSaveLoading}>{LABEL_BTN_CANCEL}</button>
                </div>
                <div className="w-full relative col-span-3">
                    <button className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]" onClick={() => handleSaveRole()} disabled={isSaveLoading}>{!isSaveLoading ? `${LABEL_BTN_SAVE}` : <span className="loading loading-spinner loading-xs text-white"></span>}</button>
                </div>
            </div>
        </>
    )
}

export default UpdateRole